import 'twin.macro';

import { Stack } from '@cheqroom/ui';
import { FC, ReactNode } from 'react';

import { StyledCard } from '../../../../App.styles';

export type SelectableListStepLayoutProps = {
	header: ReactNode;
	listSection: ReactNode;
};

export const Layout: FC<SelectableListStepLayoutProps> = ({ header, listSection }) => (
	<StyledCard sectioned>
		<Stack tw="gap-6" vertical>
			{header}
			{listSection}
		</Stack>
	</StyledCard>
);

Layout.displayName = 'SelectableListStep.Layout';
